import React, { useEffect } from 'react';
import { Modal, Form, Button, Alert } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';
import { Formik } from "formik";
import * as Yup from "yup";

import LoadingButton from '../../../components/loading_button/LoadingButton';
import { saveVacationRequest, updateVacationRequest, deleteVacationRequest, clearVacationRequestError, getVacationRequestsByEmployee  } from '../../../redux/vacations/employee_vacation_request/actions';
import messages from "../../../redux/messages";
import { sumLabHours } from '../utils/date_management';
import moment from "moment";
import toastr from "toastr"

const VacationRequestForm = ({ isEditForm, setShowModal, showModal, formInitialData, eventTypes, avaibleVac, avaibleCT }) => {
  const dispatch = useDispatch();
  const { saving: isSaveVacationRequest, error: vacationRequestSaveFail, requests } = useSelector(state => state.vacationRequests);  
  const userId = useSelector((store) => store.auth.id);

  useEffect(() => {
    if (showModal && userId) {
      dispatch(
        getVacationRequestsByEmployee(userId)
      );
    }
  }, [showModal, userId, dispatch]);

  const schema = Yup.object().shape({
    titulo: Yup.string().required("El título es requerido"),
    fecha_inicio: Yup.date()
    .required("La fecha de inicio es requerida")
    .min(moment().startOf("day"), "La fecha inicial no puede ser menor al día actual")
    .test(
      "no-solapada",
      "Ya existe una solicitud que se choca con estas fechas.",
      function (value) {
        const { fecha_fin } = this.parent;
        if (!value || !fecha_fin) return true;
        const nuevaInicio = moment(value).startOf("day");
        const nuevaFin = moment(fecha_fin).startOf("day");
        const existeSolapamiento = requests.some((req) => {
          if (
            isEditForm &&
            formInitialData?.id &&
            Number(req.id) === Number(formInitialData.id)
          ) {
            return false;
          }
          if (!req.fecha_inicio) return false;
          const solicitudInicio = moment(
            req.fecha_inicio
          ).startOf("day");
          const solicitudFin = moment(
            req.fecha_fin || req.fecha_inicio
          ).startOf("day");
          return (
            solicitudInicio.isSameOrBefore(nuevaFin) &&
            solicitudFin.isSameOrAfter(nuevaInicio)
          );
        });
        return !existeSolapamiento;
      }
    ),
    fecha_fin: Yup.date()
    .when("tipo", {
      is: (tipo) => tipo === "Vacaciones",
      then: (schema) =>
        schema
          .required("La fecha de fin es requerida")
          .min(
            Yup.ref("fecha_inicio"),
            "La fecha de fin no puede ser menor a la fecha de inicio"
          )
          .test(
            "no-solapada",
            "Ya existe una solicitud que se choca con estas fechas.",
            function (value) {
              const { fecha_inicio } = this.parent;
              if (!fecha_inicio || !value) return true;
              const nuevaInicio = moment(fecha_inicio).startOf("day");
              const nuevaFin = moment(value).startOf("day");
              const existeSolapamiento = requests.some((req) => {
                if (
                  isEditForm &&
                  formInitialData?.id &&
                  Number(req.id) === Number(formInitialData.id)
                ) {
                  return false;
                }
                if (!req.fecha_inicio) return false;
                const solicitudInicio = moment(
                  req.fecha_inicio
                ).startOf("day");
                const solicitudFin = moment(
                  req.fecha_fin || req.fecha_inicio
                ).startOf("day");
                return (
                  solicitudInicio.isSameOrBefore(nuevaFin) &&
                  solicitudFin.isSameOrAfter(nuevaInicio)
                );
              });
              return !existeSolapamiento;
            }
          ),
      otherwise: (schema) => schema.notRequired(),
    }),
    lugar: Yup.string().notRequired("La ubicación de evento"),
    comentario: Yup.string().notRequired("Los comentarios adicionales"),
    tipo: Yup.string().required("El tipo de evento es requerido"),
    horas: Yup.number().when('tipo', {
      is: (tipo) => tipo !== 'Vacaciones',
      then: Yup.number().required("Las horas son requeridas"),
      otherwise: Yup.number().notRequired()
    }),
  });

  const onSubmit = (values) => {
    let _req = { ...values, codigo_empleado: formInitialData.employee_code ? formInitialData.employee_code : "" };
    if(_req.type !== 'Vacaciones') {
      _req.end_date = sumLabHours(_req.start_date, _req.hours);
    }
    if (isEditForm) {
      dispatch(updateVacationRequest(parseInt(formInitialData.id), _req, setShowModal));
      toastr.success("Solicitud actualizada");
      console.log('update vacation request', parseInt(formInitialData.id), _req);
    } else {
      dispatch(saveVacationRequest(_req, setShowModal));
    toastr.success("Solicitud creada");
      console.log('save vacation request', _req);
    }
  }

  const onDelete = () => {
    if (window.confirm(messages.preguntaEliminar)) {
      dispatch(deleteVacationRequest(parseInt(formInitialData.id), setShowModal));
      toastr.succes("Solicitud eliminada");
      console.log('delete vacation request', parseInt(formInitialData.id));
    }
  }
  
  return (
    <Modal 
      size="lg" 
      show={showModal} 
      onHide={() => {
        setShowModal(false);
        dispatch(clearVacationRequestError());
      }}
    >
      <Formik initialValues={
        {
          titulo: formInitialData.title ? formInitialData.title : "",
          fecha_inicio: formInitialData.start ? formInitialData.start : "",
          fecha_fin: formInitialData.end ? formInitialData.end : "",
          horas: formInitialData.hours ? formInitialData.hours : "",
          lugar: formInitialData.location ? formInitialData.location : "",
          comentario: formInitialData.notes ? formInitialData.notes : "",
          tipo: formInitialData.type ? formInitialData.type : "",
        }
      }
        validationSchema={schema}
        onSubmit={onSubmit}>
        {({
          handleSubmit,
          handleChange,
          handleBlur,
          values,
          touched,
          errors,
        }) => (
          <Form onSubmit={handleSubmit}>
            <Modal.Header closeButton>
              <Modal.Title>
                {isEditForm ? 'Editar solicitud de Vacaciones' : "Crear solicitud de Vacaciones"}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {vacationRequestSaveFail && (
                <Alert variant="danger" className={"mt-4 mb-1"}>
                  {vacationRequestSaveFail}
                </Alert>
              )}
              {isEditForm && formInitialData?.estado && (
                <Alert
                  variant={
                    formInitialData.estado === "Pendiente" ? "warning" :
                    formInitialData.estado === "Aprobado" ? "success" :
                    formInitialData.estado === "Cambios" ? "info" : "secondary"
                  }
                  className="mt-2 mb-3 d-flex align-items-center"
                >
                  <strong className="mr-2">Estado:</strong> {formInitialData.estado}
                </Alert>
              )}
              {isEditForm && formInitialData?.estado === "Cambios" && (
                <Alert variant="warning" className="mt-2 mb-3">
                  El jefe solicitó cambios en esta solicitud. Revisa tu correo para ver el detalle de lo que debes ajustar.
                </Alert>
              )}
              {
                avaibleVac <= 0 && (
                  <Alert variant="danger" className={"mt-2 mb-1"}><strong>¡No tienes vacaciones disponibles!</strong></Alert>
                )
              }
              {/*
                avaibleCT <= 0 && (
                  <Alert variant="danger" className={"mt-2 mb-3"}><strong>¡No tienes tiempo compensatorio disponible para solicitar!</strong></Alert>
                )
              */}
              <Form.Group>
                <Form.Label>Título</Form.Label>
                <Form.Control 
                  type="text" 
                  name="titulo" 
                  placeholder="Ingrese el título del evento"
                  value={values.titulo} 
                  onChange={handleChange} 
                  onBlur={handleBlur} />
                {errors.titulo && touched.titulo && <div className="text-danger">{errors.titulo}</div>}
              </Form.Group>
              <Form.Group>
                <Form.Label>
                  Tipo
                </Form.Label>
                <Form.Control
                  as="select"
                  id="type"
                  name="tipo"
                  onBlur={handleBlur}
                  value={values.tipo}
                  onChange={handleChange}
                >
                  <option
                    className="text-muted"
                    value=""
                    disabled
                  >
                    Seleccionar Tipo de Solicitud
                  </option>
                  {
                    (Object.values(eventTypes)).map((eventType) => {
                      if (eventType.isSelected) {
                      return (
                        <option key={eventType.name} value={eventType.name}>{eventType.name}</option>
                      );
                      }
                      return null;
                    })
                  }
                </Form.Control>
                {errors.tipo && touched.tipo && <div className="text-danger">{errors.tipo}</div>}
              </Form.Group>
              <Form.Group>
                <Form.Label>Fecha de Inicio</Form.Label>
                <Form.Control 
                  type="date" name="fecha_inicio" value={values.fecha_inicio} onChange={handleChange} onBlur={handleBlur} />
                {errors.fecha_inicio && touched.fecha_inicio && <div className="text-danger">{errors.fecha_inicio}</div>}
              </Form.Group>
              <Form.Group>
                <Form.Label>Fecha Final</Form.Label>
                <Form.Control
                  disabled={ values.tipo !== 'Vacaciones'} 
                  type="date" 
                  name="fecha_fin" 
                  value={values.fecha_fin} 
                  onChange={handleChange} 
                  onBlur={handleBlur} />
                {errors.fecha_fin && touched.fecha_fin && <div className="text-danger">{errors.fecha_fin}</div>}
              </Form.Group>
              {values.tipo !== 'Vacaciones' && (
                <Form.Group>
                  <Form.Label>Horas</Form.Label>
                  <Form.Control 
                    type="number" 
                    name="horas" 
                    placeholder="Ingrese las horas del evento"
                    value={values.horas} 
                    onChange={handleChange} 
                    onBlur={handleBlur} />
                  {errors.horas && touched.horas && <div className="text-danger">{errors.horas}</div>}
                </Form.Group>
              )}
              <Form.Group>
                <Form.Label>Días y periodo a solicitar</Form.Label>
                <Form.Control 
                  placeholder="Ingrese los días y periodo a solicitar"
                  type="text" 
                  name="lugar" 
                  value={values.lugar} 
                  onChange={handleChange} 
                  onBlur={handleBlur} />
                {errors.lugar && touched.lugar && <div className="text-danger">{errors.lugar}</div>}
              </Form.Group>
              <Form.Group>
                <Form.Label>Comentarios</Form.Label>
                <Form.Control 
                  placeholder="Ingrese los comentarios de la solicitud"
                  as="textarea" 
                  rows={3} 
                  name="comentario" 
                  value={values.comentario} 
                  onChange={handleChange} 
                  onBlur={handleBlur} />
                {errors.comentario && touched.comentario && <div className="text-danger">{errors.comentario}</div>}
              </Form.Group>
            </Modal.Body>
            <Modal.Footer>
              {
                isEditForm && (
                  <Button
                  variant="danger"
                  type="button"
                  onClick={onDelete}
                  >
                  Eliminar
                  </Button>
                )
              }
              <Button 
                variant="secondary" 
                onClick={() => {
                  setShowModal(false);
                  dispatch(clearVacationRequestError());
                }}
              >
                Cancelar
              </Button>
                <LoadingButton
                  disabled={avaibleVac <= 0} 
                  text="Guardar" 
                  type="submit" 
                  variant="primary" 
                  isLoading={isSaveVacationRequest} />
            </Modal.Footer>
            </Form>
          )}
      </Formik>
    </Modal>
  )
}

export default VacationRequestForm;